import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../../components/Error/Error";
import Loading from "../../components/Loading/Loading";
import { useData } from "../../context/DataProvider";
import { richTextRenderer } from "../../utils/commonUtil";
import { IThemesPageItem } from "../ThemesPage/ThemesPage";
import styles from "./ThemeDetailPage.module.scss";

const ThemeDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { tema: items, isLoading, error } = useData();
  const [selectedItem, setSelectedItem] = useState<IThemesPageItem | null>(
    null
  );

  /* Örnek veri
  const items = [
    {
      baslik: "gizli",
      // ... tüm mock data buraya
    }
  ];
  */

  useEffect(() => {
    const path = window.location.pathname;
    const pathArray = path.split("/");
    const item = items.find(
      (item) =>
        item.baslik === decodeURIComponent(pathArray[pathArray.length - 1])
    );
    console.log("pathArray", pathArray);
    console.log("items", items);
    console.log("item", item);
    if (item) {
      setSelectedItem(item as IThemesPageItem);
    } else {
      setSelectedItem(null);
    }
    console.log("selectedItem", selectedItem);
  }, [items]);

  if (isLoading) return <Loading />;
  if (error) return <ErrorModal message={error.message} />;

  return (
    <div className={styles.container}>
      {/* Üstteki kuşak (yatay) görsel alanı */}
      <div className={styles.yatayGorsel}>
        {selectedItem && selectedItem.yatayGorsel ? (
          <img
            src={selectedItem.yatayGorsel}
            alt={selectedItem.baslik}
            style={{ height: "100%", maxHeight: "100%", width: "auto" }}
          />
        ) : (
          <span>image h-124px (varsayılan)</span>
        )}
      </div>

      <div className={styles.bottom}>
        {/* Sol tarafta detay görsel alanı */}
        {/* Hidden detayları gör  */}
        <div className={styles.hiddenDon}>
          <a href="/temalar"> {"<"} Temalara Dön </a>
        </div>
        <div className={styles.detayGorsel}>
          {selectedItem && (
            <img
              src={selectedItem.detayGorsel || ""}
              alt={selectedItem.baslik}
            />
          )}
        </div>

        {/* Sağ tarafta içerik alanı */}
        <div className={styles.icerik}>
          <a className={styles.temaDon} href="/temalar">
            {"<"} Temalara Dön{" "}
          </a>
          <div>{richTextRenderer(selectedItem?.aciklama || "")}</div>
          <h2>
            {selectedItem?.baslik
              ?.split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" ")}
          </h2>
          {selectedItem?.projeler && selectedItem.projeler.filter(proj => proj.status !== 2).length > 0 ? (
            <ul className={styles.projeler}>
              {selectedItem.projeler
                .filter(proj => proj.status !== 2)
                .map((proj, i) => (
                <li
                  key={i}
                  onClick={() => {
                    console.log(proj);
                    navigate("/projeDetay/" + proj.baslik);
                  }}
                >
                  {proj.baslik}
                </li>
              ))}
            </ul>
          ) : (
            <div>Projeler bulunamadı.</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThemeDetailPage;
